// extracted by mini-css-extract-plugin
export default {"subTopics":"subTopicsSection_subTopics__PdeDQ"};